import React, {useState, Suspense, useRef} from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import UISunEditor from "components/wysiwygeditor/UISunEditor";
import PageLoading from "../../../../components/loading";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "domain/main/com/file/mapng/TbComFileMapngDetail";
import UI from "components/UI";
import menuStore from "common/menu/store/MenuStore";

function ContentsContainer() {
	const history = useHistory();
	const location = useLocation();
	const [demandDetail, setDemandetail] = useState<any>([]);
	const [demandNo, setDemandNo] = useState('');
	const rtnDmdNo = useRef<any>('');
	const [flag, setFlag] = useState(false);

	// 파일
	const [fileValue] = useState(new TbComFile());
	const [loadFinish,setLoadFinish] = useState(false);

	async function getRead(dmdNo) {

		rtnDmdNo.current = dmdNo;
		console.log("rtnDmdNo : " + rtnDmdNo);

		const response:any = await CommonUtil.execute({
			url: 'usr_1908',
			data: {DEMAND_NO: dmdNo,
			}
		}).then((response: any) => {
			setDemandetail(response);

			fileValue.setTbComFileMapngDetailList([]);
			let fileList = response.FILE_INFO_LIST;
			for(let i = 0; i < fileList.length; i++){
				if(fileList[i].FILE_GB == 'FILE'){
					let fileInfo = fileList[i];

					//파일등록 정보
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(fileInfo.DWLD_ID);
					fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
					fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
					fileDetail.setStrePath(fileInfo.STRE_PATH);
					fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
					fileDetail.setFileSize(fileInfo.FILE_SIZE);
					fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
					fileDetail.setRegistDt(fileInfo.REGIST_DT);
					fileValue.putTbComFileMapngDetailList(fileDetail);
				}
			}

			setLoadFinish(true);
		}).catch((error) => {
			CommonUtil.showAxiosError(error);
			return;
		});
	}

	function pageMove(prevAndNext) {
		setDemandNo(prevAndNext);
	}


	// 수요조사 신청
	async function demandReq() {
		let dataToSend = {DEMAND_NO : rtnDmdNo.current};
		console.log(dataToSend);
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './usr_1905',
			state: { data: dataToSend }
		});
	}


	React.useEffect(() => {
		menuStore.menuList?.forEach(menu => {
			// 메뉴를 통하지 않고 바로 들어온 경우에 대한 현재 메뉴 세팅
			if(menu.menuId === "SEL1KO1AEC911DFC60")
				menuStore.setCurrentMenu(menu);
		})

		const receivedData = (location.state as any)?.data;
		const params = new URLSearchParams(location.search);
		let dmdNo = params.get("no");

		if(!flag) {
			if(receivedData != undefined && receivedData?.DEMAND_NO != ''){
				console.log("received : " + receivedData?.DEMAND_NO);
				getRead(receivedData?.DEMAND_NO);
			} else if(dmdNo != ''){
				console.log("param : " + dmdNo);
				//@ts-ignore
				dmdNo = dmdNo.replaceAll('-','');
				getRead(dmdNo);
			}
			setFlag(true);
		} else {
			getRead(dmdNo);
		}



	},[demandNo])

	if(!loadFinish)
		return (
			<PageLoading />
		)
	else
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">상생협력기금안내</Link></li>
					<li><Link to="#">수요조사</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<h1 className="tx tx-hd2">수요조사 상세</h1>
					<div className="tb tb-view">
						<div className="tb-view-top">
							<div className="tb-view-title">
								<h3 className="title">{demandDetail.TITLE}</h3>
							</div>
							<ul className="tb-view-info">
								<li>작성자<span className="val">{demandDetail.PERSON_NM}</span></li>
								<li>등록일<span className="val">{demandDetail.REG_DATE2}</span></li>
								<li>조회수<span className="val">{demandDetail.RET_CNT}</span></li>
							</ul>
						</div>
					</div>
					<div className="tb-view-file">
						<UI.FileDownloadSimpleMode value={fileValue} viewMode={"simple2"}/>
					</div>
					<div className="tb-view-cont">
						<UISunEditor value={demandDetail.CONT} displayOnly={true} readOnly={true}/>
					</div>
					{demandDetail.STS_CD == 'Y' &&
						<div className="hz-root hz-center mt30">
							<Button color='pri' size="big" onClick={() => demandReq()}>수요조사 신청</Button>
						</div>
					}
					<div className="tb-view-move">
						<ul>
							{demandDetail.PREV_DEMAND_NO != null ? (
								<li><label className="prev">이전글</label>
									<a href="#" onClick={(e) => {e.preventDefault(); pageMove(demandDetail.PREV_DEMAND_NO);}} className="tx tx-bd2 tx-link">{demandDetail.PREV_TITLE}</a>
								</li>
							) : (
								<li className="disabled"><label className="prev">이전글</label> 이전글이 없습니다.</li>
							)}
							{demandDetail.NEXT_DEMAND_NO != null ? (
								<li><label className="next">다음글</label>
									<a href="#" onClick={(e) => {e.preventDefault(); pageMove(demandDetail.NEXT_DEMAND_NO);}} className="tx tx-bd2 tx-link">{demandDetail.NEXT_TITLE}</a>
								</li>
							) : (
								<li className="disabled"><label className="next">다음글</label> 다음글이 없습니다.</li>
							)}
						</ul>
					</div>
					<div className="hz-root hz-center">
						<Button color='gray-o' size="big" href="/main/usr_1900/usr_1904">목록</Button>
					</div>
				</main>
			</div>			
		</PageContainer>
	);
}
export default ContentsContainer;